<template>
  <v-container class="home" fill-height>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <div class="report d-flex justify-center align-start" v-if="localTemperature !== undefined">
            <img class="mr-3" v-for="w in weatherIconArray" :src="weatherIconPath(w)" alt="weather icon">
            <div>
              <h2 class="text-h2">{{ localTemperature.value }}°C</h2>
              <h3 class="text-h4">{{ localTemperature.place }}</h3>

              <h5 class="text-h5">{{ humidity }}%</h5>
            </div>
          </div>
          <div class="wwarning ml-5 d-flex align-center" v-if="warning !== undefined">
            <img v-for="w in warning" :src="require(`@/assets/warning/${w.code.toLowerCase()}.png`)" :alt="w.name" :key="w.code" width="60">
          </div>

        </div>
      </v-col>
      <v-col cols="12" v-if="lastUpdate !== ''">
        <div class="d-flex align-center">
          <v-spacer></v-spacer>
          <v-icon class="mr-3" v-show="isLoading">
            mdi-loading mdi-spin
          </v-icon>
          <div class="text-caption">
            最後更新時間：{{ timeTrimmer(lastUpdate) }}
          </div>
          <v-icon class="ml-3" @click="fetchAll">
            mdi-refresh
          </v-icon>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'home',
  computed: {
    localTemperature(){
      var temp = {};
      temp = this.temperatureArray.filter(current=>current.place === this.$store.state.settings.location)[0]
      return temp
    },
    temperatureArray(){
      return this.$store.state.weatherReport.temperatureArray;
    },
    weatherIconArray(){
      return this.$store.state.weatherReport.weatherIconArray;
    },
    humidity(){
      return this.$store.state.weatherReport.humidity;
    },
    warning(){
      return this.$store.state.warning.warningArray;
    },
    isLoading(){
      return this.$store.state.weatherReport.isLoading && this.$store.state.warning.isLoading;
    },
    lastUpdate(){
      return this.$store.state.weatherReport.lastUpdate;
    }
  },
  methods: {
    weatherIconPath(icon){
      return require('@/assets/weather-icons/icon-' + icon + '.png');
    },
    fetchWeatherReport(){
      this.$store.dispatch('fetchWeatherReport')
    },
    fetchWarning(){
      this.$store.dispatch('fetchWarning')
    },
    fetchAll(){
      this.fetchWeatherReport();
      this.fetchWarning();
    }
  },
  created(){
    // this.fetchAll()
  }
}
</script>

<style lang="scss">
.home {
  width: 100%;
  max-width: 800px;
}
</style>
